module.exports = __webpack_public_path__ + "static/media/img_Inscription_free2@3x.65b538ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_Inscription_free2@3x.png
// module id = 987
// module chunks = 0